import { useMemo } from 'react';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import {
	StyledStaffTag,
	StyledStaffTagsContainer,
	StyledTooltipContainer,
} from './StaffNicknames.styled';

interface StaffNicknamesProps {
	staffNames: string[];
}

const StaffNicknames = ({ staffNames }: StaffNicknamesProps) => {
	const playerName = useObservable(rage.player.getNickname());

	const filteredStaffNames = useMemo(
		() => staffNames.filter((name) => name !== playerName),
		[playerName, staffNames],
	);

	const [firstStaffName, ...restStaffNames] = filteredStaffNames;

	if (filteredStaffNames.length === 0) {
		return null;
	}

	if (filteredStaffNames.length === 1) {
		return (
			<StyledStaffTagsContainer>
				<StyledStaffTag>
					<Text>{firstStaffName}</Text>
				</StyledStaffTag>
			</StyledStaffTagsContainer>
		);
	}

	return (
		<StyledStaffTagsContainer>
			<StyledStaffTag>
				<Text>{firstStaffName}</Text>
			</StyledStaffTag>
			<StyledStaffTag>
				<Text>+{restStaffNames.length}</Text>
			</StyledStaffTag>
			<StyledTooltipContainer>
				<Text>{restStaffNames.join(', ')}</Text>
			</StyledTooltipContainer>
		</StyledStaffTagsContainer>
	);
};

export { StaffNicknames };
